module.exports = __webpack_public_path__ + "img/magento-modules-customization@2x.7c68d789.webp";